import { z } from 'zod';

export const Login = z.object({
  email: z.string().email(),
  password: z.string().min(1),
});
export type Login = z.infer<typeof Login>;

export const ChangePassword = z.object({
  currentPassword: z.string().min(1),
  newPassword: z.string().min(10, 'errors.password_too_short'),
});

export const AssignRoles = z.object({
  roleKeys: z.array(z.string().min(1)).min(1),
});

export const UpsertRole = z.object({
  key: z.string().regex(/^[a-z][a-z0-9_]*$/),
  name: z.string().min(1).max(80),
  nameAr: z.string().max(80).optional(),
  description: z.string().max(500).optional(),
  permissions: z.array(z.string()).default([]),
});
